import React from 'react';
import './Spinner.css';

const Spinner = ({ width }) => {
    return (
        <div className="loadingio-spinner-spin-oefynqutfaf">
            <div className="ldio-a99n4ssuwle">
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
                <div>
                    <div></div>
                </div>
            </div>
        </div>
    )
}
export default Spinner;